import { render, staticRenderFns } from "./StockDispatchList.vue?vue&type=template&id=dafbe99c&"
import script from "./StockDispatchList.vue?vue&type=script&lang=js&"
export * from "./StockDispatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockDispatchList.vue"
export default component.exports